import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Sisesta sooduskood

  <span style="color:#85c1dc;">**FI:**</span>
  Syötä alennuskoodi

  <span style="color:#85c1dc;">**RU:**</span>
  Введите промо-код
*/
/* @__NO_SIDE_EFFECTS__ */
const m736 = msg(
  mf`Sisesta sooduskood`,
  mf`Syötä alennuskoodi`,
  mf`Введите промо-код`,
)

export { m736 as 'w.basket.summary.voucher' }